"use strict";

exports.__esModule = true;
var _exportNames = {
  createHistogramQuery: true
};
exports.createHistogramQuery = void 0;
var _HistogramTableElement = require("./HistogramTableElement");
Object.keys(_HistogramTableElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _HistogramTableElement[key]) return;
  exports[key] = _HistogramTableElement[key];
});
var _HistogramTableFields = require("./HistogramTableFields");
Object.keys(_HistogramTableFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _HistogramTableFields[key]) return;
  exports[key] = _HistogramTableFields[key];
});
var _HistogramDefinition = require("./HistogramDefinition");
Object.keys(_HistogramDefinition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _HistogramDefinition[key]) return;
  exports[key] = _HistogramDefinition[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});
var _createHistogramQuery = require("./createHistogramQuery");
exports.createHistogramQuery = _createHistogramQuery.createHistogramQuery;